<button
  [uiVisible]="visible"
  [uiDropdownMenu]="menu"
  [attr.aria-haspopup]="true"
  [attr.aria-expanded]="visible ? true : null"
  [attr.aria-label]="'rearrange' | localize"
  (uiVisibleChange)="handleVisibleChange($event)"
  (keydown)="onKeyDown($event)"
  ui-button
  uiShape="round"
  ui-dropdown
  uiTrigger="click"
  uiPlacement="bottomRight">
  <i ui-icon uiType="menu-horizontal"></i>
</button>
<ui-dropdown-menu #menu="uiDropdownMenu">
  <ul ui-menu role="menu">
    <li class="widget-action-item-header" *ngIf="homeWidgetService.canToggleFullWidth(this.widgetId)" role="menuitem" ui-menu-item>
      <span id="widgetActionsFullWidth">{{ "full_width" | localize }}</span>
      <ui-toggle [value]="homeWidgetService.isFullWidth(this.widgetId)" (toggled)="toggleFullWidth()" uiType="toggle-text" labelledby="widgetActionsFullWidth"></ui-toggle>
    </li>
    <li
      *ngFor="let menuItem of textMenuItems"
      [uiDisabled]="menuItem.disabled()"
      [tabindex]="menuItem.disabled() ? '-1' : '0'"
      [attr.aria-disabled]="menuItem.disabled() ? 'true' : null"
      (click)="menuItem.click()"
      role="menuitem"
      ui-menu-item>
      <i [uiType]="menuItem.iconType" uiTheme="outline" ui-icon></i>
      <span>{{ menuItem.titleKey | localize }}</span>
    </li>
  </ul>
</ui-dropdown-menu>
